module.exports = __webpack_public_path__ + "media/images/logo/Logo-Moovejob-CMJN-fond-transparent-sous-traitance-c93afda055f6819aad38e50aaa8f67b3.png";